const MAIN_SELECTOR = 'main.content-for-layout';
const MOBILE_MEDIA_QUERY = '(max-width: 749px)';

/**
 * Reads --layer-sticky so section stacking never covers the header.
 * @returns {number}
 */
function getMaxSectionZIndex() {
  const raw = getComputedStyle(document.documentElement).getPropertyValue('--layer-sticky').trim();
  const layerSticky = Number.parseInt(raw, 10);

  if (!Number.isFinite(layerSticky) || layerSticky < 2) {
    return 7;
  }

  return layerSticky - 1;
}

/**
 * Every main section needs an ascending z-index so later blocks scroll over earlier
 * sticky ones — including sections that do not have sticky enabled themselves.
 */
function applySectionStackOrder() {
  const sections = document.querySelectorAll(`${MAIN_SELECTOR} > .shopify-section`);
  const count = sections.length;
  const minZ = 1;
  const maxZ = getMaxSectionZIndex();

  for (const [index, section] of sections.entries()) {
    if (!(section instanceof HTMLElement)) continue;

    const zIndex = count <= 1 ? minZ : Math.round(minZ + (index / (count - 1)) * (maxZ - minZ));
    section.style.zIndex = String(zIndex);
  }
}

function initSectionStickyScroll() {
  applySectionStackOrder();
}

document.addEventListener('DOMContentLoaded', initSectionStickyScroll);
document.addEventListener('shopify:section:load', initSectionStickyScroll);
document.addEventListener('shopify:section:reorder', initSectionStickyScroll);

if (document.readyState !== 'loading') {
  initSectionStickyScroll();
}

window.matchMedia(MOBILE_MEDIA_QUERY).addEventListener('change', initSectionStickyScroll);
